import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { AppState, AppStateModel } from '../../app.state';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { RouteLocations } from '../../common/routing/route-locations.enum';
import { AuthenticationService } from '../../common/services/authentications.service';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, FaIconComponent, MatMenuModule, RouterLink],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  constructor(
    private _authenticationService: AuthenticationService,
  ) {
  }

  @Select(AppState)
  protected appState$!: Observable<AppStateModel>;

  protected async logoutAsync() {
    await this._authenticationService.logoutAsync();
  }

  protected readonly faChevronDown = faChevronDown;
  protected readonly faRightFromBracket = faRightFromBracket;
  protected readonly RouteLocations = RouteLocations;
}
